import React from 'react';
import '../custom_single_select/custom_sigle_select.css';
import type { PackageOptionGroup } from '../../../utils/planCategory';

// PROD-9767: the package dropdown on every membership screen, one <optgroup> per plan type.
interface PackageGroupedSelectProps {
  groups: PackageOptionGroup[];
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  name?: string;
  label?: string;
  defaultOption?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  // Bare renders only the <select>, for forms that draw their own label.
  bare?: boolean;
}

function PackageGroupedSelect({
  groups,
  value,
  onChange,
  name = 'package_uuid',
  label = 'Select Plan',
  defaultOption,
  style,
  disabled = false,
  bare = false
}: PackageGroupedSelectProps) {
  const select = (
    <select
      name={name}
      value={value}
      onChange={onChange}
      style={style}
      disabled={disabled}
      aria-label={label}
    >
      {defaultOption !== undefined ? <option value="">{defaultOption}</option> : null}
      {groups.map((group) => (
        <optgroup key={group.label} label={group.label}>
          {group.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
  if (bare) return select;
  return (
    <div className="custom-single-select">
      <div className="custom-single-select-label">{label}:</div>
      <div className="custom-single-select-inner">{select}</div>
    </div>
  );
}

export default PackageGroupedSelect;
